'use strict';
import React, { PureComponent } from 'react';
import GrupoRadioButton from '../../../../Common/GrupoRadioButton';
import DatosCriterios from './DatosCriterios';


class SeccionCriteriosContables extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {

        //ACTIONS
        const {
            cambiarOpcionComboCriterios,
            elegirOpcionSelector,
            seleccionarRadioButtonABMModelos,
            setMostrarLinkVerMas
        } = this.props;

        //DATA
        const {
            arrayCombosCriteriosContables,
            arraySelectoresCriteriosContables,
            errorValidacion,
            mostrarSpinnerModalRenglones,
            rbModalAltaEdicionRenglonContable
        } = this.props;


        return (
            <div>
                <div className="ABMModelosModalContainer__seccionCriterioContable">
                    <div className="seccionDatosGenerales__tituloSecundario ABMModelosModalContainer__tituloSecundarioGrande">Criterio de selección</div>

                    <div className="seccionDatosGenerales__tituloSecundario">Signo del importe</div>

                    <div>
                        <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierda">
                            <GrupoRadioButton 
                                activo={rbModalAltaEdicionRenglonContable.rbSignoImporte == "A" || rbModalAltaEdicionRenglonContable.rbSignoImporte == null}
                                classLabel={null}
                                estaHabilitado={true}
                                label={"Ambos"}
                                nombre={"rbSignoImporte"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={"A"}
                            />
                        </div>

                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonMedio">
                            <GrupoRadioButton 
                                activo={rbModalAltaEdicionRenglonContable.rbSignoImporte == "P" || rbModalAltaEdicionRenglonContable.rbSignoImporte == "+"}
                                classLabel={null}
                                estaHabilitado={true}
                                label={"Positivo"}
                                nombre={"rbSignoImporte"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={"P"}
                            />
                        </div>

                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                            <GrupoRadioButton 
                                activo={rbModalAltaEdicionRenglonContable.rbSignoImporte == "N" || rbModalAltaEdicionRenglonContable.rbSignoImporte == "-"}
                                classLabel={null}
                                estaHabilitado={true}
                                label={"Negativo"}
                                nombre={"rbSignoImporte"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={"N"}
                            />
                        </div>
                    </div>
                </div>

                <div>
                    {mostrarSpinnerModalRenglones ?
                        <div className="ABMModelos loadingIndividualContainer">
                            <div className="loadingSmall"></div>
                        </div>
                    :
                        <DatosCriterios 
                            cambiarOpcionComboCriterios={cambiarOpcionComboCriterios}
                            elegirOpcionSelector={elegirOpcionSelector}
                            setMostrarLinkVerMas={setMostrarLinkVerMas}

                            arrayCombosCriteriosContables={arrayCombosCriteriosContables}
                            arraySelectoresCriteriosContables={arraySelectoresCriteriosContables}
                            errorValidacion={errorValidacion}
                        />
                    }
                </div>
            </div>
        );
    }
}

export default SeccionCriteriosContables;